(function () {
  function getMiniCart() {
    return document.querySelector('mini-cart');
  }

  function getCartAddUrl() {
    return (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
  }

  function getSectionsToRenderIds() {
    const miniCart = getMiniCart();
    if (!miniCart || typeof miniCart.getSectionsToRender !== 'function') return null;
    try {
      return miniCart.getSectionsToRender().map((s) => s.id);
    } catch (e) {
      return null;
    }
  }

  function getBaseConfig() {
    if (typeof fetchConfig === 'function') return fetchConfig('javascript');
    return { method: 'POST', headers: { Accept: 'application/json' } };
  }

  function getSectionsUrl() {
    return `${window.location.pathname}${window.location.search || ''}`;
  }

  async function addItems(items, opts) {
    opts = opts || {};
    const miniCart = getMiniCart();
    const wantSections = opts.sections !== false;
    const sections = (wantSections && miniCart) ? getSectionsToRenderIds() : null;

    const payload = {
      items: (items || []).map((i) => {
        const out = {
          id: Number(i.id),
          quantity: Number(i.quantity || 1),
        };
        if (i.selling_plan) out.selling_plan = Number(i.selling_plan);
        if (i.properties && typeof i.properties === 'object') out.properties = i.properties;
        return out;
      }),
    };

    if (sections && sections.length) {
      payload.sections = sections;
      payload.sections_url = getSectionsUrl();
    }

    const config = getBaseConfig();
    config.method = 'POST';
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';
    config.body = JSON.stringify(payload);

    const res = await fetch(getCartAddUrl(), config);
    const json = await res.json();

    if (json && json.status) {
      throw json;
    }

    if (miniCart && json && json.sections) {
      miniCart.renderContents(json);
    } else if (miniCart && opts.openDrawer) {
      miniCart.open();
    }

    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: json } }));
    document.dispatchEvent(new CustomEvent('rrg:cart:added', { detail: { response: json, items: payload.items } }));

    return json;
  }

  async function addItem(id, quantity, opts) {
    opts = opts || {};

    const item = {
      id: id,
      quantity: quantity || 1,
    };

    if (opts.selling_plan) item.selling_plan = opts.selling_plan;
    if (opts.properties && typeof opts.properties === 'object') item.properties = opts.properties;

    return addItems([item], opts);
  }

  window.RRGCart = window.RRGCart || {};
  window.RRGCart.addItems = addItems;
  window.RRGCart.addItem = addItem;
})();
